import { createContext } from 'react';
import { InitialState } from '@Hooks/modalManager/modal.types.ts';
import { initialState } from '@Hooks/modalManager/mondal.consts.ts';


export const modalContext = createContext<{
  state: InitialState;
  setModal: (modalConfig: Partial<InitialState>) => void;
}>({
  state: initialState,
  setModal: () => {},
});
